exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".UIScreen{overflow:hidden}.UIScreen__content{overflow-y:auto}", ""]);
